module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block row"
  }, _vm._l((_vm.records.items), function(familyInfo) {
    return _c('div', {
      staticClass: "col-md-6 col-lg-3"
    }, [_c('div', {
      staticClass: "card card-cascade narrower"
    }, [_c('div', {
      staticClass: "view overlay hm-white-slight"
    }, [_c('div', {
      staticClass: "background img-fluid",
      style: ({
        backgroundImage: 'url(\'' + (familyInfo.photo || '/network/static/img/default_family_photo.jpg') + '\')'
      })
    }), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/family/' + familyInfo.id
      }
    }, [_c('div', {
      staticClass: "mask waves-effect waves-light"
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "card-block text-center"
    }, [_c('h4', {
      staticClass: "card-title"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(familyInfo.name) + "\n\t\t\t\t\t\t\t\t"), (familyInfo.paid) ? _c('small', [_c('i', {
      staticClass: "fa fa-star-o"
    })]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "card-text"
    }, [_vm._v(_vm._s(_vm.$config.lists.countries[familyInfo.country].text) + " / " + _vm._s(_vm.$config.lists.states[familyInfo.state].text))])]), _vm._v(" "), _c('div', {
      staticClass: "card-footer text-center"
    }, [_c('p', _vm._l((familyInfo.users), function(child) {
      return _c('span', {
        staticClass: "child-age text-gray",
        attrs: {
          "title": child.name
        }
      }, [_c('i', {
        staticClass: "child-icon fa",
        class: child.role == 'son' ? 'fa-male' : 'fa-female'
      }), _vm._v(" " + _vm._s(_vm.getChildAge(child)) + "г\n\t\t\t\t\t\t\t")])
    }))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('f-pager', {
    attrs: {
      "total": _vm.records.total,
      "clickhandler": _vm.pageClick
    }
  })], 1)])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Семействa")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-702bd4ae!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/family/FamilyList.vue
// module id = 662
// module chunks = 1